export default function getErrorMessage(err) {
    if (!err) return "Unknown error";
    if (typeof err === "string") return err;
    if ("status" in err) {
      const data = err.data;
      if (typeof data === "string") return data.slice(0, 200);
      if (data && typeof data === "object")
        return (data.message || data.error || "Request failed").slice(0, 200);
      return `Request failed with status ${String(err.status)}`;
    }
    if ("message" in err && err.message) return String(err.message).slice(0, 200);
    return "Unknown error";
  }